import type { JSX } from "react";

import { Pill, type PillProps } from "@mantine/core";

interface IVRTagProps extends PillProps {
    type?: "default" | "warning";
}
export function IVRTag({ children, type = "default", ...rest }: IVRTagProps): JSX.Element {
    return (
        <Pill
            bg={type === "warning" ? "warning.5" : "primary.2"}
            c="var(--mantine-color-black)"
            fw={700}
            fz="xs"
            p="0 .1875rem"
            radius={2}
            size="xs"
            w="fit-content"
            {...rest}
        >
            {children}
        </Pill>
    );
}
